module.exports = __webpack_public_path__ + "static/media/Residential_63.c8ab5f32.jpg";